var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"img-logout"},[_c('ImageNav'),_c('Nav')],1),_c('div',[_c('Header')],1),_c('div',[_c('Content')],1),_c('div',{staticClass:"footer-gestion"},[_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }